import * as React from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useEffect, useState} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import {Alert, AppBar, Card, TextField, Grid} from "@mui/material";
import {DeleteOutline, Add, Save, Edit} from "@mui/icons-material";
import {
  Checkbox,
  Container,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {Label} from "@mui/icons-material";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {POST, PATCH, GET} from "APIclient";
import Snackbar from "@mui/material/Snackbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useLocation, useNavigate} from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import numberToWord from "number-to-words-indian-currency";
import properties from "constants/ApplicationConstants";

export default function CreateNewOffer() {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(null);
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const handleCloseSnackbar = () => setSnackbar(null);
  const [probationMonth, setProbationMonth] = React.useState("");
  const [inputs, setInputs] = React.useState({designationName: ""});
  const [display, setDisplay] = React.useState(false);
  const [designationList, setDesignationList] = React.useState([]);
  const [isViewMode, setIsViewMode] = useState(false);
  let [formData, setFormData] = React.useState({
    offerId: "",
    offerDate: dayjs(new Date()),
    salutation: "",
    message: "",
    firstName: "",
    middleName: "",
    lastName: "",
    emailAddress: "",
    mobileNo: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    country: "",
    city: "",
    state: "",
    pincode: "",
    designation: "",
    resignationNotice: "",
    terminableNotice: "",
    probationApplicable: "0",
    probationMonth: "",
    probationStartDate: "",
    probationEndDate: "",
    joinDate: dayjs(),
    joinType: "",
    issuedBy: "",
    salary: "",
    ctcInWords: "",
    performanceBonus: "",
    performanceBonusInWords: "",
    reimburseAmount: "",
    reimburseAmountInWords: "",
    variableAmount: "",
    variableAmountInWords: "",
    joiningBonus: "",
    joiningBonusInWords: "",
    variablePayReason: "",
    appointmentIssuedBy: 2,
    addedOn: dayjs(new Date()),
    cancelReason: "",
    officeLocation: "",
    status: 1
  });

  React.useEffect(() => {
    if (location.pathname === "/editOffer" || location.pathname === "/viewOffer") {
      if (location.pathname === "/viewOffer") {
        setIsViewMode(true);
      }
      const fetchUrl = `admin/offer/index?offerId=${location.state}`;
      const fetchData = async () => {
        try {
          const response = await GET(fetchUrl);
          const data = response?.data?.data;
          const offerData = data.paginatedData ? data.paginatedData[0] : data?.paginatedData;

          let calculatedProbationMonth = "";
          if (offerData?.probationStartDate && offerData?.probationEndDate) {
            const start = dayjs(offerData.probationStartDate);
            const end = dayjs(offerData.probationEndDate);
            calculatedProbationMonth = end.diff(start, "month").toString();
          }

          setFormData(prevFormData => ({
            ...prevFormData,
            ...offerData,
            probationMonth: calculatedProbationMonth,
            country: offerData?.country || "",
            state: offerData?.state || "",
            city: offerData?.city || ""
          }));
          if (offerData?.country) {
            fetchStatesAndCities(offerData?.country, offerData?.state);
          }
          if (offerData?.salary) {
            const salaryInWords = convertSalaryToWords(offerData.salary);
            setFormData(prevFormData => ({
              ...prevFormData,
              ctcInWords: salaryInWords
            }));
          }
          if (offerData?.variableAmount) {
            const variableAmountInWords = convertSalaryToWords(offerData.variableAmount);
            setFormData(prevFormData => ({
              ...prevFormData,
              variableAmountInWords: variableAmountInWords
            }));
          }
          if (offerData?.performanceBonus) {
            const performanceBonusInWords = convertSalaryToWords(offerData.performanceBonus);
            setFormData(prevFormData => ({
              ...prevFormData,
              performanceBonusInWords: performanceBonusInWords
            }));
          }
          if (offerData?.reimburseAmount) {
            const reimburseAmountInWords = convertSalaryToWords(offerData.reimburseAmount);
            setFormData(prevFormData => ({
              ...prevFormData,
              reimburseAmountInWords: reimburseAmountInWords
            }));
          }
          if (offerData?.joiningBonus) {
            const joiningBonusInWords = convertSalaryToWords(offerData?.joiningBonus);
            setFormData(prevFormData => ({
              ...prevFormData,
              joiningBonusInWords: joiningBonusInWords
            }));
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    } else if (location.pathname === "/offer") {
      location.state = null;
    }
  }, []);

  const getUrl = `admin/list-designation`;
  const fetchDesignationList = async () => {
    try {
      const response = await GET(getUrl);
      const rawList = response?.data?.data;

      const formattedList = rawList.map(item => {
        let value = "";
        const designation = item.designationName.toLowerCase();
        if (designation === "manager - hr") {
          value = "manager_hr";
        } else if (designation === "operations manager") {
          value = "operations_manager";
        } else if (designation === "senior project manager") {
          value = "senior_project_manager";
        } else if (designation === "hr executive") {
          value = "hr_executive";
        } else if (designation === "qa engineer") {
          value = "qa_engineer";
        } else {
          value = designation.replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "");
        }
        return {
          label: item.designationName,
          value: value
        };
      });

      setDesignationList(formattedList);
    } catch (error) {
      console.error("Error fetching designation list:", error);
    }
  };

  React.useEffect(() => {
    fetchDesignationList();
  }, []);

  const [errors, setErrors] = React.useState({});
  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [country, setCountry] = React.useState([]);

  const fetchStatesAndCities = async (country, stateValue) => {
    try {
      const url = `admin/location-list/${country}`;
      const response = await GET(url);
      if (response.status === 200) {
        const data = response.data.data;
        setStates(data);
        if (stateValue) {
          const selectedState = data.find(state => state.state === stateValue);
          setCities(selectedState ? selectedState.cities : []);
        } else {
          setCities([]);
        }
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const countryUrl = "admin/countries";
        const response = await GET(countryUrl);
        const data = response?.data?.data;
        if (data && response?.data?.statusCode === 200 && Array.isArray(data)) {
          setCountry(data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  const handleCountryChange = e => {
    const selectedCountry = e.target.value;
    setStates([]);
    setCities([]);
    setFormData({...formData, country: selectedCountry, state: "", city: ""});
    fetchStatesAndCities(selectedCountry, "");
    if (selectedCountry) {
      setErrors(prev => ({...prev, country: ""}));
    }
  };

  const handleStateChange = e => {
    const selectedState = e.target.value;
    setFormData({
      ...formData,
      state: selectedState,
      city: ""
    });
    const stateData = states.find(state => state.state === selectedState);
    setCities(stateData ? stateData.cities : []);
    validateField("state", selectedState);
    validateField("city", "");
  };

  const handleCityChange = e => {
    const selectedCity = e.target.value;
    setFormData({...formData, city: selectedCity});
    validateField("city", selectedCity);
  };

  const convertSalaryToWords = salary => {
    if (!salary || isNaN(salary)) {
      return "";
    }
    const words = numberToWord(salary);
    return words.charAt(0).toUpperCase() + words.slice(1);
  };

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === "salary") {
      const salaryValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: salaryValue,
        ctcInWords: convertSalaryToWords(salaryValue)
      }));
    }

    if (name === "variableAmount") {
      const variableAmountValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: variableAmountValue,
        variableAmountInWords: convertSalaryToWords(variableAmountValue)
      }));
    }

    if (name === "performanceBonus") {
      const performanceBonusValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: performanceBonusValue,
        performanceBonusInWords: convertSalaryToWords(performanceBonusValue)
      }));
    }

    if (name === "reimburseAmount") {
      const reimburseAmountValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: reimburseAmountValue,
        reimburseAmountInWords: convertSalaryToWords(reimburseAmountValue)
      }));
    }

    if (name === "joiningBonus") {
      const joiningBonusValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: joiningBonusValue,
        joiningBonusInWords: convertSalaryToWords(joiningBonusValue)
      }));
    }

    if (name === "probationMonth" && value !== "") {
      const startDate = dayjs(formData.probationStartDate);
      const newEndDate = startDate.add(parseInt(value), "month");
      setFormData(prevData => ({
        ...prevData,
        probationEndDate: newEndDate.format("YYYY-MM-DD")
      }));
    }

    if (name === "designation") {
      setFormData(prevState => ({
        ...prevState,
        designation: value
      }));
    }
    validateField(name, value);
  };

  const fieldLabels = {
    salutation: "Salutation",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    mobileNo: "Mobile No",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    country: "Country Name",
    state: "State",
    city: "City",
    pincode: "Pincode",
    designation: "Designation",
    resignationNotice: "Resignation Notice",
    terminableNotice: "Terminable Notice",
    probationApplicable: "Probation Applicable",
    probationMonth: "Probation Month",
    probationStartDate: "Probation Start Date",
    probationEndDate: "Probation End Date",
    joinDate: "Join Date",
    joinType: "Join Type",
    issuedBy: "Issued By",
    salary: "Salary",
    variableAmount: "Variable Amount",
    variablePayReason: "Variable Pay Reason",
    appointmentIssuedBy: "Appointment Issued By",
    addedOn: "Added On",
    cancelReason: "Cancel Reason",
    officeLocation: "Office Location"
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    const stringValue = value !== undefined && value !== null ? String(value) : "";
    if (
      [
        "salutation",
        "addressLine1",
        "addressLine2",
        "addressLine3",
        "country",
        "city",
        "state",
        "designation",
        "resignationNotice",
        "terminableNotice",
        "variableAmount",
        "variablePayReason",
        "appointmentIssuedBy",
        "joinType",
        "officeLocation",
        "issuedBy"
      ].includes(name)
    ) {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      }
    } else if (name === "firstName" || name === "lastName") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (/[^a-zA-Z\s]/.test(value)) {
        errorMessage = `${fieldLabels[name]} contains invalid character.`;
      }
    } else if (name === "emailAddress") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        errorMessage = `Please enter a valid email address.`;
      }
    } else if (name === "mobileNo") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (!/^\d{10}$/.test(value)) {
        errorMessage = `Please enter a valid 10-digit mobile number.`;
      } else if (/^0{10}$/.test(value)) {
        errorMessage = `Mobile number cannot be all zeros.`;
      }
    } else if (name === "pincode") {
      const pincodeRegex = /^[0-9]{6}$/;
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (!pincodeRegex.test(value)) {
        errorMessage = `Please enter a valid 6-digit pincode.`;
      }
    } else if (name === "salary") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (isNaN(value) || parseFloat(value) <= 0) {
        errorMessage = `Please enter a valid positive number for ${fieldLabels[name]}.`;
      }
    } else if (name === "probationMonth") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (isNaN(value) || parseInt(value) <= 0) {
        errorMessage = `Please enter a valid positive number for ${fieldLabels[name]}.`;
      }
    } else if (["probationStartDate", "probationEndDate", "joinDate"].includes(name)) {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (!dayjs(value).isValid()) {
        errorMessage = `Please enter a valid date for ${fieldLabels[name]}.`;
      }
    } else if (name === "joinType") {
      if (stringValue.trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (!["Fresher", "Experience", "Temporary", "Consultant"].includes(value)) {
        errorMessage = `Please select a valid ${fieldLabels[name]}.`;
      }
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage
    }));
  };

  const handleDesignation = async () => {
    const url = `admin/add-designation`;
    try {
      let response = await POST(url, {designationName: inputs.designationName});
      response = response?.data;
      if (response?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage("Designation added successfully.");
        setOpen(true);
        setDisplay(false);
        setInputs({designationName: ""});
        await fetchDesignationList();
      }
    } catch (error) {
      error = error?.response;
      if (error?.statusCode == 409) {
        setSnakColor("error");
        setSnakMessage(error.data?.message);
        setOpen(true);
      } else if (error?.statusCode == 406) {
        setSnakColor("error");
        setSnakMessage(error.data?.message);
        setOpen(true);
      } else if (error?.statusCode == 403) {
        setSnakColor("error");
        setSnakMessage(error?.message);
        setOpen(true);
      } else if (error?.statusCode == 404) {
        setSnakColor("error");
        setSnakMessage(error?.message);
        setOpen(true);
      } else {
        setSnakColor("error");
        setSnakMessage(error);
        setOpen(true);
      }
    }
  };

  const handleDesignationChange = event => {
    const {name, value} = event.target;
    setInputs(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;
    setFormData(prev => {
      const updatedData = {
        ...prev,
        [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
      };
      if (field === "probationStartDate" && prev.probationMonth) {
        const months = parseInt(prev.probationMonth);
        if (!isNaN(months)) {
          updatedData.probationEndDate = validDate.add(months, "month").format("YYYY-MM-DD");
        }
      }
      return updatedData;
    });
    validateField(field, validDate?.format("YYYY-MM-DD") || "");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const numberToWords = num => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    if (num === 0) return "Zero";

    let words = "";
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        words = `${convertHundreds(num % 1000)} ${thousands[i]} ${words}`;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return words.trim();
  };

  const convertHundreds = num => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];

    if (num === 0) return "";
    if (num < 20) return ones[num];
    else if (num < 100) return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`;
    else return `${ones[Math.floor(num / 100)]} Hundred ${convertHundreds(num % 100)}`;
  };

  const capitalize = str => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
  };

  const handleSubmit = async () => {
    const requiredFields = [
      "salutation",
      "firstName",
      "lastName",
      "emailAddress",
      "mobileNo",
      "addressLine1",
      "addressLine2",
      "addressLine3",
      "country",
      "city",
      "state",
      "pincode",
      "designation",
      "resignationNotice",
      "terminableNotice",
      "joinType",
      "issuedBy",
      "officeLocation",
      "offerDate",
      "joinDate"
    ];
    requiredFields.forEach(field => {
      validateField(field, formData[field]);
    });

    let url = ``;
    formData = {
      offerDate: formData.offerDate,
      salutation: capitalize(formData.salutation),
      firstName: capitalize(formData.firstName),
      middleName: capitalize(formData.middleName),
      lastName: capitalize(formData.lastName),
      emailAddress: formData.emailAddress,
      mobileNo: formData.mobileNo,
      addressLine1: formData.addressLine1,
      addressLine2: formData.addressLine2,
      addressLine3: formData.addressLine3,
      country: formData.country,
      city: formData.city,
      state: formData.state,
      pincode: formData.pincode,
      designation: formData.designation,
      resignationNotice: formData.resignationNotice,
      terminableNotice: formData.terminableNotice,
      probationApplicable: formData.probationApplicable,
      probationStartDate: formData.probationStartDate == null ? "" : formData.probationStartDate,
      probationEndDate: formData.probationEndDate == null ? "" : formData.probationEndDate,
      joinDate: formData.joinDate,
      joinType: formData.joinType,
      issuedBy: formData.issuedBy,
      salary: formData.salary ? formData.salary : "0",
      variableAmount: formData.variableAmount ? formData.variableAmount : "0",
      joiningBonus: formData.joiningBonus ? formData.joiningBonus : "0",
      variablePayReason: formData.variablePayReason,
      appointmentIssuedBy: formData.appointmentIssuedBy,
      appointmentDate: formData.appointmentDate,
      performanceBonus: formData.performanceBonus ? formData.performanceBonus : "0",
      reimburseAmount: formData.reimburseAmount ? formData.reimburseAmount : "0",
      officeLocation: formData.officeLocation
    };

    if (location.state) {
      let offerId = location.state;
      url = `admin/offer/edit/${offerId}`;
      try {
        let response = await PATCH(url, formData);
        response = response?.data;
        if (response?.statusCode === 200) {
          setSnakColor("success");
          setSnakMessage("Offer Update successfully");
          setOpen(true);
        }
      } catch (error) {
        error = error?.response;
        if (error?.statusCode == 409) {
          setSnakColor("error");
          setSnakMessage(error.data?.message);
          setOpen(true);
        } else if (error?.statusCode == 406) {
          setSnakColor("error");
          setSnakMessage(error.data?.message);
          setOpen(true);
        } else if (error?.statusCode == 403) {
          setSnakColor("error");
          setSnakMessage(error?.message);
          setOpen(true);
        } else if (error?.statusCode == 404) {
          setSnakColor("error");
          setSnakMessage(error?.message);
          setOpen(true);
        } else {
          setSnakColor("error");
          setSnakMessage(error);
          setOpen(true);
        }
      }
      navigate("/Offer_List");
    } else {
      url = "admin/offer/add";
      try {
        let response = await POST(url, formData);
        response = response.data;
        if (response?.statusCode === 200) {
          setSnakColor("success");
          setSnakMessage("Offer added successfully");
          setOpen(true);
          setTimeout(() => {
            navigate("/Offer_List");
          }, 2000);
        }
      } catch (error) {
        error = error ? error : error.response;
        if (error?.statusCode == 409) {
          setSnakColor("error");
          setSnakMessage(error?.message);
          setOpen(true);
        } else if (error?.statusCode == 406) {
          setSnakColor("error");
          setSnakMessage(error?.message);
          setOpen(true);
        } else if (error?.statusCode == 403) {
          setSnakColor("error");
          setSnakMessage(error?.message);
          setOpen(true);
        } else if (error?.statusCode == 400) {
        } else {
        }
      }
    }
  };

  const getCountryCode = countryName => {
    let countryObject = "";
    for (const item of country) {
      if (item.countryName === countryName || item.countryCode === countryName) {
        countryObject = item;
      }
    }
    return countryObject;
  };

  const getState = state => {
    for (const item of states) {
      if (item.state === state) {
        return item;
      }
    }
    return "";
  };

  const [hrManager, setHrManager] = useState([]);

  React.useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        const data = response?.data?.data;
        setHrManager(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHrManager();
  }, []);

  const commonInputSx = {
    maxWidth: "300px",
    width: "100%",
    "& .MuiInputBase-root": {
      fontSize: "0.875rem"
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.875rem"
    },
    "& label.Mui-error": {
      color: "inherit"
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: "0.75rem"
    }
  };

  const parseAmount = value => parseFloat(value) || 0;
  const totalCTC =
    parseAmount(formData?.salary) +
    parseAmount(formData?.variableAmount) +
    parseAmount(formData?.performanceBonus) +
    parseAmount(formData?.joiningBonus);

  const totalSalaryInWords = convertSalaryToWords(totalCTC);

  const handleEditOffer = () => {
    setIsViewMode(false);
    const offerId = location.state;
    navigate("/editOffer", {state: offerId});
  };

  const isCreateMode = location.pathname === "/offer";
  const isEditMode = location.pathname === "/editOffer";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Card sx={{maxWidth: "1200px", mx: "auto"}}>
          <MDBox p={2}>
            <MDTypography variant="body2" fontWeight="medium" mb={1}>
              {isViewMode ? "View Offer" : isEditMode ? "Edit Offer" : "Create New Offer"}
            </MDTypography>
            <Grid container spacing={1.5}>
              {/* Offer Date and Edit Button */}
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      sx={commonInputSx}
                      size="small"
                      label={
                        <span>
                          Offer Date <span style={{color: properties.colors.Red}}>*</span>
                        </span>
                      }
                      name="offerDate"
                      value={formData?.offerDate ? dayjs(formData.offerDate) : null}
                      onChange={date => handleDateChange(date, "offerDate")}
                      readOnly={isViewMode}
                      shouldDisableDate={date => {
                        const day = dayjs(date).day();
                        return day === 0 || day === 6;
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" justifyContent="flex-end">
                {!isCreateMode && !isEditMode && (
                  <MDButton
                    color="info"
                    variant="contained"
                    startIcon={<Edit sx={{fontSize: 20, color: "white"}} />}
                    onClick={handleEditOffer}
                    disabled={!isViewMode}
                    sx={{height: "36px", fontSize: "0.875rem"}}
                  >
                    Edit Offer
                  </MDButton>
                )}
              </Grid>

              {/* Candidate Name */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Candidate Name <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>
                    Mr./Mrs.<span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    name="salutation"
                    value={formData?.salutation}
                    onChange={handleChange}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="Mr.">Mr.</MenuItem>
                    <MenuItem value="Mrs.">Mrs.</MenuItem>
                    <MenuItem value="Ms.">Ms.</MenuItem>
                  </Select>
                  {errors.salutation && <FormHelperText error>{errors.salutation}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  sx={commonInputSx}
                  name="firstName"
                  value={formData ? formData.firstName : ""}
                  type="text"
                  label={
                    <span>
                      First Name <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  onChange={handleChange}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  inputProps={{readOnly: isViewMode}}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  sx={commonInputSx}
                  name="middleName"
                  value={formData?.middleName}
                  type="text"
                  label="Middle Name"
                  variant="standard"
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  sx={commonInputSx}
                  name="lastName"
                  value={formData?.lastName}
                  type="text"
                  label={
                    <span>
                      Last Name <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  size="small"
                />
              </Grid>

              {/* Contact Information */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Contact Information <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={commonInputSx}
                  type="email"
                  name="emailAddress"
                  value={formData?.emailAddress}
                  label={
                    <span>
                      Email <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.emailAddress}
                  helperText={errors.emailAddress}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={commonInputSx}
                  type="text"
                  name="mobileNo"
                  label={
                    <span>
                      Mobile <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  value={formData?.mobileNo}
                  onChange={handleChange}
                  variant="standard"
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.mobileNo}
                  helperText={errors.mobileNo}
                  size="small"
                />
              </Grid>

              {/* Present Address */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Present Address <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  sx={commonInputSx}
                  type="text"
                  name="addressLine1"
                  label={
                    <span>
                      Address Line 1 <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  value={formData?.addressLine1}
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.addressLine1}
                  helperText={errors.addressLine1}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  sx={commonInputSx}
                  type="text"
                  name="addressLine2"
                  label={
                    <span>
                      Address Line 2 <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  value={formData?.addressLine2}
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.addressLine2}
                  helperText={errors.addressLine2}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  sx={commonInputSx}
                  type="text"
                  name="addressLine3"
                  label={
                    <span>
                      Landmark <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  value={formData?.addressLine3}
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.addressLine3}
                  helperText={errors.addressLine3}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>
                    Country <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    name="country"
                    value={formData.country || ""}
                    onChange={handleCountryChange}
                    label="Country"
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {country && country.length > 0 ? (
                      country.map(country => (
                        <MenuItem key={country.countryId} value={country.countryCode}>
                          {country.countryName} ({country.countryCode})
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No countries available</MenuItem>
                    )}
                  </Select>
                  {errors.country && <FormHelperText error>{errors.country}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>
                    State <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    name="state"
                    value={formData.state || ""}
                    label="State"
                    onChange={handleStateChange}
                    disabled={!formData.country}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {states && states.length > 0 ? (
                      states.map((state, index) => (
                        <MenuItem key={index} value={state.state}>
                          {state.state}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No states available</MenuItem>
                    )}
                  </Select>
                  {errors.state && <FormHelperText error>{errors.state}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>
                    City <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    name="city"
                    value={formData.city || ""}
                    label="City"
                    onChange={handleCityChange}
                    disabled={!formData.state}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {cities && cities.length > 0 ? (
                      cities.map((city, index) => (
                        <MenuItem key={index} value={city}>
                          {city}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No cities available</MenuItem>
                    )}
                  </Select>
                  {errors.city && <FormHelperText error>{errors.city}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  sx={commonInputSx}
                  type="text"
                  name="pincode"
                  label={
                    <span>
                      Pincode <span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  value={formData?.pincode}
                  onChange={handleChange}
                  inputProps={{readOnly: isViewMode}}
                  error={!!errors.pincode}
                  helperText={errors.pincode}
                  size="small"
                />
              </Grid>

              {/* Designation */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Designation <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="designation">
                    Designation <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="designation"
                    id="designation"
                    value={formData?.designation || ""}
                    name="designation"
                    label="Designation"
                    onChange={handleChange}
                    readOnly={isViewMode}
                    error={!!errors.designation}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {designationList?.map(designation => (
                      <MenuItem key={designation.value} value={designation.value}>
                        {designation.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.designation && (
                    <FormHelperText error>{errors.designation}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" alignItems="center">
                <MDButton
                  color="success"
                  variant="contained"
                  startIcon={<Add sx={{fontSize: 20, color: "white"}} />}
                  onClick={() => setDisplay(!display)}
                  disabled={isViewMode}
                  sx={{height: "36px", fontSize: "0.875rem"}}
                >
                  Add Designation
                </MDButton>
              </Grid>
              {display && (
                <Grid item xs={12}>
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <MDInput
                      sx={commonInputSx}
                      type="text"
                      name="designationName"
                      value={inputs.designationName}
                      onChange={handleDesignationChange}
                      label="New Designation"
                      variant="standard"
                      disabled={isViewMode}
                      readOnly={isViewMode}
                      size="small"
                    />
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={handleDesignation}
                      disabled={isViewMode}
                      sx={{height: "36px", fontSize: "0.875rem"}}
                    >
                      OK
                    </MDButton>
                  </MDBox>
                </Grid>
              )}

              {/* Joining Details */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Joining Details <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      sx={commonInputSx}
                      size="small"
                      label={
                        <span>
                          Joining Date <span style={{color: properties.colors.Red}}>*</span>
                        </span>
                      }
                      name="joinDate"
                      value={formData ? dayjs(formData.joinDate) : null}
                      onChange={date => handleDateChange(date, "joinDate")}
                      readOnly={isViewMode}
                      error={!!errors.joinDate}
                      helperText={errors.joinDate}
                      shouldDisableDate={date => {
                        const day = dayjs(date).day();
                        return day === 0 || day === 6;
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="joinType">
                    Joining Type <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="joinType-label"
                    value={formData ? formData.joinType : ""}
                    name="joinType"
                    label="joinType"
                    onChange={handleChange}
                    IconComponent={ExpandMoreIcon}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="Fresher">Fresher</MenuItem>
                    <MenuItem value="Experience">Experience</MenuItem>
                    <MenuItem value="Temporary">Temporary</MenuItem>
                    <MenuItem value="Consultant">Consultant</MenuItem>
                  </Select>
                  {errors.joinType && <FormHelperText error>{errors.joinType}</FormHelperText>}
                </FormControl>
              </Grid>

              {/* Salary Details */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Salary Details
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  name="salary"
                  label="Fixed Salary"
                  value={formData?.salary}
                  onChange={handleChange}
                  variant="standard"
                  sx={commonInputSx}
                  inputProps={{readOnly: isViewMode}}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="ctcInWords"
                  disabled
                  label="Fixed Salary In Words"
                  value={formData?.ctcInWords}
                  variant="standard"
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="variableAmount"
                  label="Variable Amount"
                  value={formData?.variableAmount}
                  onChange={handleChange}
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="variableAmountInWords"
                  label="Variable Amount In Words"
                  value={formData?.variableAmountInWords}
                  disabled
                  variant="standard"
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="performanceBonus"
                  label="Performance Bonus"
                  value={formData?.performanceBonus}
                  onChange={handleChange}
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="performanceBonusInWords"
                  label="Performance Bonus In Words"
                  value={formData.performanceBonusInWords}
                  disabled
                  variant="standard"
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="joiningBonus"
                  label="Joining Bonus"
                  value={formData?.joiningBonus}
                  onChange={handleChange}
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="joiningBonusInWords"
                  label="Joining Bonus In Words"
                  value={formData.joiningBonusInWords}
                  disabled
                  variant="standard"
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="totalCTC"
                  label="Total Salary (CTC)"
                  value={totalCTC && totalCTC !== 0 ? totalCTC : ""}
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="totalCTCInWords"
                  label="Total Salary In Words"
                  value={totalSalaryInWords}
                  variant="standard"
                  disabled
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="reimburseAmount"
                  label="Reimburse Amount"
                  value={formData?.reimburseAmount}
                  onChange={handleChange}
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  type="text"
                  name="reimburseAmountInWords"
                  label="Reimburse Amount In Words"
                  value={formData.reimburseAmountInWords}
                  disabled
                  variant="standard"
                  sx={commonInputSx}
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  sx={commonInputSx}
                  multiline
                  maxRows={3}
                  type="text"
                  name="variablePayReason"
                  value={formData?.variablePayReason}
                  onChange={handleChange}
                  label="Variable Pay Reason"
                  variant="standard"
                  disabled={isViewMode}
                  readOnly={isViewMode}
                  size="small"
                />
              </Grid>

              {/* Notice Period */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Notice Period <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="resignationNotice">
                    In Case Of Resignation <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    value={formData?.resignationNotice}
                    name="resignationNotice"
                    label="resignationNotice"
                    onChange={handleChange}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {[...Array(10).keys()].map(i => (
                      <MenuItem key={i + 1} value={i + 1}>
                        {i + 1} Months
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.resignationNotice && (
                    <FormHelperText error>{errors.resignationNotice}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="terminableNotice">
                    In Case Of Terminable <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    value={formData?.terminableNotice}
                    name="terminableNotice"
                    label="terminableNotice"
                    onChange={handleChange}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {[...Array(10).keys()].map(i => (
                      <MenuItem key={i + 1} value={i + 1}>
                        {i + 1} Months
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.terminableNotice && (
                    <FormHelperText error>{errors.terminableNotice}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Probation Period */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Probation Period <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>Probation Applicable</InputLabel>
                  <Select
                    value={formData?.probationApplicable}
                    name="probationApplicable"
                    label="Probation Applicable"
                    onChange={handleChange}
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="0">No</MenuItem>
                    <MenuItem value="1">Yes</MenuItem>
                  </Select>
                  {errors.probationApplicable && (
                    <FormHelperText error>{errors.probationApplicable}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      sx={commonInputSx}
                      size="small"
                      label="Probation Start Date"
                      name="probationStartDate"
                      value={
                        formData
                          ? formData.probationApplicable === "0"
                            ? null
                            : dayjs(formData.probationStartDate)
                          : null
                      }
                      onChange={date => handleDateChange(date, "probationStartDate")}
                      disabled={formData?.probationApplicable === "0"}
                      readOnly={isViewMode}
                      minDate={formData?.joinDate ? dayjs(formData.joinDate) : undefined}
                      shouldDisableDate={date => {
                        const day = dayjs(date).day();
                        return day === 0 || day === 6;
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel>No. of Months</InputLabel>
                  <Select
                    labelId="probationMonth"
                    id="probationMonth"
                    value={formData?.probationMonth}
                    name="probationMonth"
                    label="No. of Months"
                    onChange={handleChange}
                    readOnly={isViewMode}
                    disabled={formData?.probationApplicable === "0"}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {[...Array(10).keys()].map(i => (
                      <MenuItem key={i + 1} value={i + 1}>
                        {i + 1} Months
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      sx={commonInputSx}
                      size="small"
                      label="Probation End Date"
                      name="probationEndDate"
                      value={
                        formData
                          ? formData.probationApplicable === "0"
                            ? null
                            : dayjs(formData.probationEndDate)
                          : null
                      }
                      onChange={date => handleDateChange(date, "probationEndDate")}
                      disabled={formData?.probationApplicable === "0"}
                      readOnly={isViewMode}
                      minDate={formData?.joinDate ? dayjs(formData.joinDate) : undefined}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>

              {/* Issued By and Office Location */}
              <Grid item xs={12}>
                <MDTypography variant="body2" fontWeight="medium">
                  Additional Details <span style={{color: properties.colors.Red}}>*</span>
                </MDTypography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="issuedBy">
                    Issued By <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="issuedBy"
                    id="issuedBy"
                    value={formData?.issuedBy}
                    name="issuedBy"
                    onChange={handleChange}
                    label="Issued By"
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {hrManager?.map(manager => (
                      <MenuItem key={manager.empId} value={manager.empId}>
                        {`${manager.firstName} ${manager.lastName}`}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.issuedBy && <FormHelperText error>{errors.issuedBy}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" sx={commonInputSx}>
                  <InputLabel id="officeLocation">
                    Office Location <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="officeLocation"
                    id="officeLocation"
                    value={formData?.officeLocation}
                    name="officeLocation"
                    onChange={handleChange}
                    label="Office Location"
                    readOnly={isViewMode}
                    size="small"
                  >
                    <MenuItem value="">
                      <em>Select Location</em>
                    </MenuItem>
                    <MenuItem value="India">India</MenuItem>
                    <MenuItem value="US">US</MenuItem>
                  </Select>
                  {errors.officeLocation && (
                    <FormHelperText error>{errors.officeLocation}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Buttons */}
              <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
                <MDBox sx={{display: "flex", gap: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "120px", fontSize: "0.875rem", height: "36px"}}
                    onClick={() => navigate("/Offer_List")}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{
                      width: "120px",
                      fontSize: "0.875rem",
                      background: properties.colors.bgcolorbluethem,
                      height: "36px"
                    }}
                    onClick={handleSubmit}
                    disabled={isViewMode}
                  >
                    Save
                  </MDButton>
                </MDBox>
              </Grid>
            </Grid>

            <Snackbar
              open={open}
              anchorOrigin={{vertical: "top", horizontal: "right"}}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert
                autoHideDuration={1200}
                onClose={handleClose}
                severity={snakColor === "success" ? "success" : "error"}
                variant="filled"
                sx={{width: "100%", color: "#fff", fontSize: "0.875rem"}}
              >
                {snakMessage}
              </Alert>
            </Snackbar>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
